import { useMemo, useState } from 'react'

import { AppReviewsTableColumns } from './columns'

import { AppReviewStatus } from '@/api/app-client'
import { DataTable } from '@/components/ui/data-table'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from '@/components/ui/select'
import { useQueryListAppReviews } from '@/services/app.service'

type StatusFilter = AppReviewStatus | 'all'

const STATUS_OPTIONS: { value: StatusFilter; label: string }[] = [
  { value: 'all', label: 'All' },
  { value: 'pending', label: 'Pending' },
  { value: 'approved', label: 'Approved' },
  { value: 'rejected', label: 'Rejected' }
]

export const AppReviewsList = () => {
  const [status, setStatus] = useState<StatusFilter>('all')

  const { data, isPending } = useQueryListAppReviews()

  const filteredReviews = useMemo(
    () =>
      (data ?? []).filter(
        (review) => status === 'all' || review.review_status === status
      ),
    [data, status]
  )

  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-center gap-2">
        <span className="text-sm text-muted-foreground">Status</span>
        <Select
          onValueChange={(value) => setStatus(value as StatusFilter)}
          value={status}
        >
          <SelectTrigger className="w-[180px] text-primary">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {STATUS_OPTIONS.map(({ value, label }) => (
              <SelectItem key={value} value={value}>
                {label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      <DataTable
        columns={AppReviewsTableColumns}
        data={filteredReviews}
        isLoading={isPending}
        tableConfigName="app-reviews"
      />
    </div>
  )
}
